import React, { useState, useEffect, ChangeEvent } from 'react';
import { useDispatch } from 'react-redux';
import { useIntl } from 'react-intl';
import { Button, Typography } from '@material-ui/core';
import { makeStyles } from '@material-ui/core/styles';
import { useAuth, useAlert, useSaveShootingDraft } from 'hooks';
import { hideModal } from 'state/actions';
import { LOADING } from 'state/constants';
import { ALERT, MODAL } from 'config/constants';
import { HvModal, HvButton } from 'components';
import { Shooting, Listing } from 'models';

const useStyles = makeStyles({
  description: {
    fontSize: 14,
    marginBottom: 16,
  },
  cancel: {
    textTransform: 'none',
    textDecoration: 'underline',
    marginRight: 'auto',
  },
});

interface Props {
  shooting: Shooting;
}

function DraftShootingSaveModal({ shooting }: Props) {
  const intl = useIntl();
  const styles = useStyles();
  const dispatch = useDispatch();

  const { token } = useAuth();
  const { displayAlert } = useAlert();
  const { saved, saving, saveDraft } = useSaveShootingDraft();
  const onClose = () => {
    dispatch(hideModal(MODAL.DRAFT_SHOOTING_SAVE));
  };

  const onConfirmSaveDraft = async () => {
    saveDraft(token, shooting, shooting.listing);
  };
  useEffect(() => {
    if (saving !== LOADING.FINISHED) {
      return;
    }

    if (saved) {
      dispatch(hideModal(MODAL.DRAFT_SHOOTING_SAVE));
      dispatch(hideModal(MODAL.SHOOTING_EDIT));
      displayAlert(ALERT.SUCCESS, intl.formatMessage({ id: 'shooting.detail.deleteDraftSuccess' }));
    } else {
      displayAlert(ALERT.ERROR, intl.formatMessage({ id: 'shooting.detail.cancelError' }));
    }

    onClose();
  }, [saving]);
  const buttons = (
    <>
      <Button className={styles.cancel} onClick={onClose}>
        {intl.formatMessage({ id: 'shooting.create.confirm.keepEditing' })}
      </Button>
      <HvButton onClick={onConfirmSaveDraft}>
        {intl.formatMessage({ id: 'shooting.create.confirm.saveDraftAndExit' })}
      </HvButton>
    </>
  );

  return (
    <HvModal
      title={intl.formatMessage({ id: 'shooting.create.confirm.confirmDraftTitle' })}
      buttons={buttons}
      onClose={onClose}
    >
      <Typography className={styles.description}>
        {intl.formatMessage({ id: 'shooting.create.confirm.confirmDraftMessage' })}
      </Typography>
    </HvModal>
  );
}
export default DraftShootingSaveModal;
